import { render, staticRenderFns } from "./PickedInsectsDraw.vue?vue&type=template&id=2c18ae68&"
import script from "./PickedInsectsDraw.vue?vue&type=script&lang=js&"
export * from "./PickedInsectsDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c18ae68')) {
      api.createRecord('2c18ae68', component.options)
    } else {
      api.reload('2c18ae68', component.options)
    }
    module.hot.accept("./PickedInsectsDraw.vue?vue&type=template&id=2c18ae68&", function () {
      api.rerender('2c18ae68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_legacy/PickedInsectsDraw.vue"
export default component.exports